import { couponDetailIntial } from '../../store/InitialStore';
import * as types from '../../actions/ActionTypes';

export default function CouponDetailReducer(
  state = couponDetailIntial,
  action
) {
  const { type, payload } = action;

  switch (type) {
    case types.COUPON_DETAIL_LOADING:
      return { loading: true, detail: {}, error: false };
    case types.COUPON_DETAIL_SUCCESS:
      return { loading: false, detail: payload, error: false };
    case types.COUPON_DETAIL_ERROR:
      return { loading: false, detail: payload, error: true };
    default:
      return state;
  }
}
